<!--  -->
<template>
  <div class="service-score-wrapper">
    <div class="header_bg">
      <p>尊敬的用户，您可通过以下方式，进入应用评分界面，对本服务进行评分</p>
    </div>
    <div class="step">
      <div class="step_one">
        <div class="one_tile">
          <p><i></i><span>第一步：</span>通过应用商店查找“i襄阳”</p>
        </div>
        <div class="one_content">
          打开手机应用商店/软件商店/应用宝等，搜索“i襄阳”，点击“i襄阳”进入应用详情页
        </div>
      </div>
      <div class="step_one step_two">
        <div class="one_tile">
          <p><i></i><span>第二步：</span>评分及评价</p>
        </div>
        <div class="one_content">
          点击评论，进行评分及评价
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import checkAJB from "@/utils/checkAlipayJSBridge";
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    checkAJB.setTitle("服务评分");
  },
};
</script>

<style lang="less" scoped>
.service-score-wrapper {
  min-height: 100vh;
  background: #fff;
  padding: 14px 16px;
  .header_bg {
    width: 100%;
    height: 93px;
    background: url("~@/assets/img/score_bg.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      padding: 0 20px;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .step {
    .step_one {
      margin-top: 15px;
      .one_tile {
        font-size: 16px;
        p {
          display: flex;
          align-items: center;
          i {
            margin-right: 8px;
            width: 3px;
            height: 12px;
            background: rgba(18, 135, 249, 1);
          }
          span {
          }
        }
      }
      .one_content {
        margin-top: 12px;
        font-size: 14px;
        color: #999;
        line-height: 19px;
      }
    }
    .step_two {
      margin-top: 30px;
    }
  }
}
</style>
